<template>
  <vs-select v-model="label">
    <vs-select-item
      :key="index"
      :value="item"
      :text="item"
      v-for="(item, index) in labels"
    />
  </vs-select>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["condition", "automationId"],
  data() {
    return {
      label: "",
    };
  },
  methods: {
    render() {
      return {
        label: this.label,
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
      labels: "guestSegmentation/labels",
    }),
  },
  async mounted() {
    await this.$store.dispatch("guestSegmentation/get", false);
    if (this.condition) {
      this.label = this.condition.label;
    }
  },
};
</script>

<style lang="scss">
</style>